// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1dCaS","inner":"Footer_inner__1k2NE","nextIcon":"Footer_nextIcon__3wmH8","innerLeft":"Footer_innerLeft__2AP9a"};